import { render, staticRenderFns } from "./BlockPropertyHistory.vue?vue&type=template&id=17dde4bc&scoped=true&"
import script from "./BlockPropertyHistory.vue?vue&type=script&lang=js&"
export * from "./BlockPropertyHistory.vue?vue&type=script&lang=js&"
import style0 from "./BlockPropertyHistory.vue?vue&type=style&index=0&id=17dde4bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dde4bc",
  null
  
)

export default component.exports